// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1rP9S","dragIcon":"SortableItem_dragIcon__11Hhs","disabled":"SortableItem_disabled__23qqN"};